import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';
import { breakpoints } from 'styles/breakpoints';

export const StyledFabelTownBundle = styled.div`
  font-family: var(--font-family), Arial;
  font-weight: bold;
  height: 100%;

  .container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 15px;
    background: linear-gradient(145deg, #2A1B5D, #1A0F3A);
    position: relative;
    overflow: hidden;

    .product {
      height: 100%;
      border-radius: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;
      padding: 8px;
      background: ${(props: any) => props.backgroundSrc ? `url("${props.backgroundSrc}")` : createGradientOrSolid(props.backgroundColor)};
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      position: relative;

      .decorative-block {
        width: 100%;
        min-height: 0;
        border-radius: 8px;
        background: rgba(0, 0, 0, 0.20);
        padding: 6px;
        display: flex;
        align-content: center;
        justify-content: center;
        flex-wrap: wrap;
        flex: 1;
        row-gap: 4px;
        column-gap: 8px;
      }

      .product-container {
        width: 34%;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .image-container {
        height: ${(props: any) => props.imageSize || 40}px;
        width: ${(props: any) => props.imageSize || 40}px;

        .image {
          height: 100%;
          width: 100%;
          object-fit: cover;
          position: relative;
          z-index: 1;
        }

        @media (max-width: ${breakpoints.mobileL}) {
          height: ${(props: any) => props.products?.length === 1 && '64px'};
          width: ${(props: any) => props.products?.length === 1 && '64px'};
        }
      }

      .amount-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center !important;

        .main-amount {
          color: #FFFFFF;
          font-weight: 800;
          text-align: center;
          text-shadow: 
            -0.5px -0.5px 0 #6F0EA2,
            0.5px -0.5px 0 #6F0EA2,
            -0.5px  0.5px 0 #6F0EA2,
            0.5px  0.5px 0 #6F0EA2;
          line-height: 14px;
        }

        .crossed-amount {
          color: #FFF;
          text-align: center;
          text-decoration: line-through;
          font-weight: 800;
          text-decoration-line: line-through;
          text-decoration-color: #d8232a;
          text-decoration-thickness: 1.5px;
        }
      }

      .price-container {
        width: 100%;
        border: 2px solid #8023D1;
        border-radius: 8px;
        margin-top: 6px;
        font-weight: 200;

        .stroked {
          margin-left: 4px;
          font-weight: 800;
        }

        .final-price {
          font-weight: 800;
        }
      }
    }
  }

  .bundlePriceButton {
    height: 32px;
    border-radius: 7px;
    border: 2px solid #75FFFF;
  }

  @media (min-width: ${breakpoints.desktop}) {
    .bundlePriceButton {
      height: 37px;
    }

    &.bundle--iphone-mock {
      .bundlePriceButton {
        height: 32px;
      }
    }
  }
` as any;
